export enum Features {
  FISCALIZATION = "FISCALIZATION",
  DISCOUNT = "DISCOUNT",
  GROUPS = "GROUPS",
  PRODUCT_VARIANTS = "PRODUCT_VARIANTS",
  RESTAURANT_VARIANTS = "RESTAURANT_VARIANTS",
  LAYOUTS = "LAYOUTS",
  FLOOR_PLANS = "FLOOR_PLANS",
  CREDIT_NOTE = "CREDIT_NOTE",
  GIFT_CARD = "GIFT_CARD",
  AUTOMATIC_BOOKKEEPING = "AUTOMATIC_BOOKKEEPING",
  RECEIPT_LOGO = "RECEIPT_LOGO",
  EXTRA_PRODUCT_FIELDS = "EXTRA_PRODUCT_FIELDS",
  CUSTOMER_DISPLAY = "CUSTOMER_DISPLAY",
  BARCODE_SCANNING = "BARCODE_SCANNING",
  SIMPLE_STOCK = "SIMPLE_STOCK",
  PHONE_SUPPORT = "PHONE_SUPPORT",
  BUNDLE_MANAGEMENT = "BUNDLE_MANAGEMENT",
  LABEL_PRINTING = "LABEL_PRINTING",
  ORDER = "ORDER",
  INVOICE = "INVOICE",
  SERIAL_SCALE = "SERIAL_SCALE",
  PURCHASE_NOTE = "PURCHASE_NOTE",
  PRODUCT_INFO_BOX = "PRODUCT_INFO_BOX",
  PRODUCT_IMAGES = "PRODUCT_IMAGES",
  MODIFIERS = "MODIFIERS",
  TIPS = "TIPS",
  PREP_TICKETS = "PREP_TICKETS",
  COMBINED_PREP_TICKETS = "COMBINED_PREP_TICKETS",
  SAVE_TABS = "SAVE_TABS",
  SPLIT_TABS = "SPLIT_TABS",
  BILL_PREVIEW = "BILL_PREVIEW",
  TAKEOUT_PRICE = "TAKEOUT_PRICE",
  ONLINE_ORDER = "ONLINE_ORDER",
  PURCHASE_PRICE = "PURCHASE_PRICE",
  STAFF = "STAFF",
  INTAKE = "INTAKE",
  PRODUCT_SYNC = "PRODUCT_SYNC",
  STOCK_TAKE = "STOCK_TAKE",
  STOCK_LOCATIONS = "STOCK_LOCATIONS",
  STOCK_POLICIES = "STOCK_POLICIES",
  INVENTORY_COSTING = "INVENTORY_COSTING",
  SUPPLIERS = "SUPPLIERS",
  OFFERS = "OFFERS",
  CUSTOMERS = "CUSTOMERS",
  SERVICE_ORDERS = "SERVICE_ORDERS",
  EXTERNAL_INTEGRATIONS = "EXTERNAL_INTEGRATIONS",
  PUBLIC_API = "PUBLIC_API",
}

const knownFeatures = new Set<unknown>(Object.values(Features));

export const isKnownFeature = (value: unknown): value is Features =>
  knownFeatures.has(value);
